import {QTableColumn} from "pansx-utils/src/index";


export  class CollectCompany{
    public  userId?: number;
    public  userName='';
    public  companyName='';
    public customerAppId?: number;
    public isReviewPass?: boolean;


    public static  of(o: unknown): CollectCompany {
        return Object.assign(new CollectCompany(),o);
    }

    public static getColumns(): QTableColumn[]{
        return [

            {name:'userId',field:'userId',label:'收集用户ID'},
            {name:'userName',field:'userName',label:'收集用户名字'},
            {name:'companyName',field:'companyName',label:'收集公司名字'},
            {name:'customerAppId',field:'customerAppId',label:'收集公司名字'},
        ]
    }

    public getColumnLabel(field: string) {
        const columns = CollectCompany.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field,
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}